export const BASE_ANALYTICS_HIERARCHY = ['select_category', 'Quick links'];
